import { Button, Tooltip } from '@customerio/pluma-components/react';
import { usePermissions } from '@customerio/hydra-permissions/react';
import { useProductTaxonomy } from '@/services/product-taxonomy';

type AddPeopleButtonProps = {
  /** The add-people flow's URL — Ember-owned until its own migration (FPS-2618) lands. */
  href: string;
};

/**
 * The page-header "Add people" action. The add flow itself is still served by
 * the embedded app, so this links into it rather than opening the add-people
 * modal in place (that modal ports with the create flow, FPS-2618). Disabled
 * without the create permission, with the same tooltip copy as the modal
 * trigger it replaces.
 */
export function AddPeopleButton({ href }: AddPeopleButtonProps) {
  const taxonomy = useProductTaxonomy();
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission('journeys/people/create');

  return (
    <Tooltip content="Contact an Admin to access this feature." isDisabled={canCreate} isCustom>
      {(context) => (
        <Button
          variant="primary"
          isDisabled={!canCreate}
          href={canCreate ? href : undefined}
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
        >
          Add {taxonomy.term('people.plural')}
        </Button>
      )}
    </Tooltip>
  );
}
